// @flow

import styled, { type ReactComponentStyled } from 'styled-components';

import type { ColorHex, Shift } from '../../typings';
import DisplayText from '../Text/DisplayText';
import noteIcon from '../../../assets/svg/boxIcons/note-white.svg';
import taskIcon from '../../../assets/svg/boxIcons/task.svg';

type BoxProps = {
  backgroundColor: ColorHex
};

const Box: ReactComponentStyled<BoxProps> = styled.div`
  display: flex;
  flex-direction: column;
  height: 24px;
  justify-content: center;
  flex: 1;
  background-color: ${props => props.backgroundColor};
  padding: 16px 16px;
  border-radius: 4px;
`;

const Row = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
`;

type Props = {
  shift: Shift
};

export default function ShiftBox({ shift }: Props) {
  const { displayLabel, location, position, summary, taskInstances } = shift;
  const hasTasks = Boolean(taskInstances?.length);
  const hasSummary = Boolean(summary?.length);

  return (
    <Box backgroundColor={position.color}>
      <Row>
        <DisplayText fontSize="11px" lineHeight="12px" bold>
          {displayLabel}
        </DisplayText>
        {hasTasks && <img src={taskIcon} />}
      </Row>

      <Row>
        <DisplayText fontSize="11px" lineHeight="12px" bold>
          {location.name} • {position.name}
        </DisplayText>
        {hasSummary && <img src={noteIcon} />}
      </Row>
    </Box>
  );
}
